import CryptoJS from 'crypto-js';

// 对称解密方法，参数：后端返回的整个data，返回：解密后的数据
function decrypt(data){
    // 常量：iv列表
    let ary_ivs = ['tudfstevaustweli', 'delibejishanheqi', 'enxdyqrsoqwinofs', 'mpiksotudmghbtiw'];

    // 获取data
    let Base64CBC = data.codestring;

    // console.log("Base64CBC",Base64CBC)
    let ivnumber = data.pagnumber
    let key = data.pagnameid

    // 解码数据
    let iv = CryptoJS.enc.Utf8.parse(ary_ivs[ivnumber]);
    key = CryptoJS.enc.Utf8.parse(key);

    // 解密data
    var decrypted = CryptoJS.AES.decrypt(Base64CBC, key, { iv: iv, mode: CryptoJS.mode.CBC });
    let decrypted2 = decrypted.toString(CryptoJS.enc.Utf8);
    let obj_records = JSON.parse(decrypted2);

    return obj_records
}

// 封装的get方法，参数：url，返回：requestdata
function requestGet_WithOutDecrypt(requesturl){
    return new Promise((resolve, reject) => {
        // setTimeout(resolve, ms, 'done');
        let url = requesturl;
        let options = {
            method: "GET",
        }          
        //发起fetch
        fetch(url, options).then(
            (response) => {
                // console.log("response",response);
                return response.json()
            }
        ).then(    //若通信完成，从response中获取数据
            (data) => {
                resolve(data);
            }
        ).catch(    //若出错，打印error
            (error) => {
                console.log(error)
                reject(error)
            }
        )
    });
}

// 封装的GET方法并解密；参数：url；返回：对称解密后的requestdata
function requestGet(requesturl){
    return new Promise((resolve, reject) => {
        // setTimeout(resolve, ms, 'done');
        let url = requesturl;
        let options = {
            method: "GET",
        }          
        //发起fetch
        fetch(url, options).then(
            (response) => {
                // console.log("response",response);
                return response.json()
            }
        ).then(    //若通信完成，从response中获取数据
            (data) => {
                // console.log("request data", data);
                let plaintext = decrypt(data)
                // console.log(plaintext)
                resolve(plaintext);
            }
        ).catch(    //若出错，打印error
            (error) => {
                console.log(error)
                reject(error)
            }
        )
    });
}

// 封装的POST方法；参数：url，formdata对象；返回：requestdata
function requestPost_WithOutDecrypt(requesturl,requestdata){
    return new Promise((resolve, reject) => {
        // setTimeout(resolve, ms, 'done');
        let url = requesturl;

        let options = {
            method: "POST",
            body:requestdata,
        }
        //发起fetch
        fetch(url, options).then(
            (response) => {
                // console.log("response",response);
                return response.json()
            }
        ).then(    //若通信完成，从response中获取数据
            (data) => {
                // console.log("request data", data);
                resolve(data);
            }
        ).catch(    //若出错，打印error
            (error) => {
                console.log(error)
                reject(error)
            }
        )
    });
}

// 封装的POST方法并解密；参数：url，formdata对象；返回：对称解密后的requestdata
function requestPost(requesturl,requestdata){
    return new Promise((resolve, reject) => {
        // setTimeout(resolve, ms, 'done');
        let url = requesturl;

        let options = {
            method: "POST",
            body:requestdata,
        }
        //发起fetch
        fetch(url, options).then(
            (response) => {
                // console.log("response",response);
                return response.json()
            }
        ).then(    //若通信完成，从response中获取数据
            (data) => {
                // console.log("request data", data);
                let plaintext = decrypt(data)
                // console.log(plaintext)
                resolve(plaintext);
            }
        ).catch(    //若出错，打印error
            (error) => {
                console.log(error)
                reject(error)
            }
        )
    });
}

// 获取url参数；参数：字段名key，返回：字段值value
function getUrlparameter(e){
    let loc = window.location.href;
    let parameters = decodeURI(loc.substr(loc.indexOf("?")+1, loc.length-loc.indexOf("?"))).split("&");
    let paValues = {}
    for (let i = 0; i < parameters.length; i++) {
        let key = parameters[i].substr(0,parameters[i].indexOf("="))
        let value = parameters[i].substr(parameters[i].indexOf("=")+1, parameters[i].length-parameters[i].indexOf("="));
        paValues[key] = value;
    }
    return paValues[e];
}

// 获取整个url参数；参数：无；返回：所有参数键值对的对象
function getAllUrlparameter(){
    let loc = window.location.href;
    let parameters = decodeURI(loc.substr(loc.indexOf("?")+1, loc.length-loc.indexOf("?"))).split("&");
    let paValues = {}
    for (let i = 0; i < parameters.length; i++) {
        let key = parameters[i].substr(0,parameters[i].indexOf("="))
        let value = parameters[i].substr(parameters[i].indexOf("=")+1, parameters[i].length-parameters[i].indexOf("="));
        paValues[key] = value;
    }
    return paValues;
}

// 用户行为检测
function requestLog(sourcelink,jwt){
    if(jwt==undefined){jwt='eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOiJkODE3Nzk4MS1kYzQ3LTQ1OWYtODg2MS03OTUwYTY1MWMyYjUiLCJvcHRpZCI6ImQ4MTc3OTgxLWRjNDctNDU5Zi04ODYxLTc5NTBhNjUxYzJiNSIsImV4cCI6MTA1NDkwNjk5NjJ9.8y9BbE45SQGw4VDgEzZ8LxBNrv-C4SG_2wsSEAHgVrA'}

      return new Promise((resolve, reject) => {
        // setTimeout(resolve, ms, 'done');
        let url = `https://gateway1.moxidata.cn/crm/webrights/`;

        let formdata = new FormData();
        formdata.append("method", "pagelog")
        formdata.append("strcode", jwt)
        formdata.append("sourcelink", sourcelink)

        let options = {
            method: "POST",
            body:formdata,
        }
        //发起fetch
        fetch(url, options).then(
            (response) => {
                // console.log("response",response);
                return response.json()
            }
        ).then(    //若通信完成，从response中获取数据
            (data) => {
                // console.log("request data", data);
                let plaintext = decrypt(data)
                // console.log(plaintext)
                resolve(plaintext);
            }
        ).catch(    //若出错，打印error
            (error) => {
                console.log(error)
                reject(error)
            }
        )
    });
   
}

export {decrypt,
    requestGet,
    requestGet_WithOutDecrypt,
    requestPost,
    requestPost_WithOutDecrypt,
    getUrlparameter,
    getAllUrlparameter,
    requestLog,
};